module.exports = __webpack_public_path__ + "img/rogers-waterfront.735d7863.jpg";